import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class Badge extends React.PureComponent {
    static propTypes = {
        /** Contents of the pill */
        children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        /** The largest number to show in the pill. Any values larger than the max are shown as the max + */
        max: PropTypes.number,

        size: PropTypes.oneOf(['md', 'lg']),

        /** The visual appearance of the pill */
        appearance: PropTypes.oneOf([
            'default',
            'primary',
            'important',
            'info',
            'success',
        ]),

        /** Additional class */
        className: PropTypes.string,
    };

    static defaultProps = {
        children: 0,
        max: 99,
        appearance: 'default',
        size: 'md',
    };

    renderFormattedNumber() {
        let { children, max } = this.props;
        let numberToShow = 0;
        let suffix = '';

        if (typeof children !== 'number') {
            return numberToShow;
        }

        if (children < 0) {
            children = 0;
        }

        if (max < 0) {
            max = 0;
        }

        if (max && max < children) {
            numberToShow = max;
            suffix = '+';
        } else {
            numberToShow = children;
        }

        const formatted = numberToShow.toLocaleString('en');

        return `${formatted}${suffix}`;
    }

    render() {
        const { appearance, max, children, className, size, ...rest } = this.props;

        return (
            <span
                data-component="Badge"
                className={cx('sarsa-badge', appearance, `size-${size}`, className)}
                {...rest}
            >
                {typeof children === 'number' ? (
                    this.renderFormattedNumber()
                ) : (
                    <span className="contents">{children}</span>
                )}
            </span>
        );
    }
}
